module.exports = __webpack_public_path__ + "img/lock-document.f8864476.svg";